import React, { Component } from 'react';
import FileUploader from 'react-firebase-file-uploader';
import firebase from '../../firebase';
import { Animated } from "react-animated-css";

import Header from '../../components/Header';
import Loading from '../../components/Loading';
import NoLocationPlaceHolder from '../../components/NoLocationPlaceholder';
import { NOTIFICATIONS, ERROR_MESSAGES } from '../../config';

import {
          DATE_OPTIONS,
          UPLOADED_TEXT
       } from './constants';

import {UPDATE_MENU_URL} from '../../config';

class Update extends Component {
  constructor(props){
    super(props);
    this.state = {
      errorName: '',
      menuLink: '',
      menuUpload: '',      
      isUploading: false,
      uploadError: false,
      notification: '',
      error: ''
    }    
  }

  /**
   * Signal that file uploading has started
   */
  handleUploadStart(){
    this.setState({isUploading: true});
  }

  /**
   * Signal error on file upload
   * @param error : name of error
   */    
  handleUploadError(error){
      this.setState({isUploading: false, uploadError: true});
  }
  
  /**
   * Upon success of image saving, adds the file name of saved image to menuUpload link
   * @param filename : name of file to save  
   */
  handleUploadSuccess(filename){
      let currentMenuName = this.state.menuUpload;
      if (currentMenuName == "") this.setState({menuUpload: filename, isUploading: false, uploadError: false});
      else{
        currentMenuName += ', ';
        currentMenuName += filename;
        this.setState({menuUpload: currentMenuName, isUploading: false, uploadError: false}); 
      }
  }
  
  /**
   * Generates a filename composed of the restaurant name and a random string
   */
  generateFileName(){
    let restaurantName = this.props.client.locations[this.props.activeLocation].name.replace(/\s+/, "-");
    let randomString = Math.random().toString(36).substring(6);
    return restaurantName + '-' + randomString;
  }

  /**
   * Performs API call to submit a menu update
   */
  submitMenu(){
    if(this.state.menuLink.length == 0 && this.state.menuUpload.length == 0) {
      this.setState({uploadError: true});
      return;
    }
    this.setState({isUploading: true});
    let self = this;
    let restaurant = this.props.client.locations[this.props.activeLocation];
    let date = new Date(new Date().getTime()).toLocaleDateString(DATE_OPTIONS);

    //XHR is used since zapier does not support axios via the browser
    try {
      let xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function(){
        if(this.readyState == 4 && this.status == 200){
          self.setState({isUploading: false, uploadError: false, menuUpload: '',notification: NOTIFICATIONS.MENU_UPLOAD, error: ''});
        }
      }
      xhr.open("POST", UPDATE_MENU_URL());
      xhr.send(JSON.stringify({
        "date": date,
        "id": restaurant.id,
        "address": restaurant.address,
        "menus": self.state.menuUpload || self.state.menuLink,
        "name": restaurant.name
      }));
    } catch(e) {
      this.setState({isUploading: false, uploadError: true, error: ERROR_MESSAGES.UPLOAD_ERROR,notification:''});
    }    
  }

  /**
  * Renders placeholder component if user has not added a location yet
  */
  get noLocation() {
    return (
      <div>
        {this.header}
        <div className="pageContainer">
          <NoLocationPlaceHolder />
        </div>
      </div>
    )
  }

  /**
   * Render spinner
   */
  get spinner() {
    return (
      <div className="form-spinner">
        <Loading />
      </div>
    )
  }  

  get header(){
    return(
      <Header
        pageName="UPDATE MENU"
      />
    )
  }

  get renderNotification(){
    let style;
    if(this.state.notification != ''){
        style = "ErrorGreen";
    } else if(this.state.error != ''){
        style = "ErrorRed";
    }
    
    return style && (
        <Animated 
            animationIn="shake" 
            animationOut="fadeOut" 
            isVisible={true}
            test={this.state.forgotPassword}
            >
            <div className="rightSide">
                <div className="RegistrationCard" id={style} >
                <div className="RegistrationCardBody">
                    {this.state.notification}
                </div>
                </div>
            </div>
        </Animated>
    );
  }
  
  get havingProblemsCard() {
    return (
      <div className="dashboardCard">
        <div className="dashboardCardBody">
          <div className="dashboardCardHeading">
            Having Problems?
          </div>
          <div className="classText">
            <p>Contact us in the chat box on the bottom right corner.</p>
          </div>
        </div>
      </div>
    )
  }

  render() {

  if(!this.props.client){
    return null;
  } 

  if(!this.props.client.locations || this.props.client.locations.length < 1){
    return this.noLocation;
  }

    return (      
      <div className="animated fadeIn">
        {this.header}
        <div className="pageContainer">
          <div className="row noMargin">
            {this.renderNotification}
          </div>
          <div className="row">
            <div className="dashboardCard">
              <div className="dashboardCardBody">
                  <div className="dashboardCardHeading">
                    Menu Changed? 
                  </div>
                  <div className="dashboardCardSubHeading">Send us your new menu links</div>
                  <textarea
                    type="text"
                    id="company"
                    placeholder="Enter links to your menus separated by comma or space (3 links max for free users)"
                    className="form-control"
                    onChange={(event) => this.setState({ menuLink: event.target.value })}
                  />
                  <div className="centered-row">  <img src="img/icons/or.svg"/> </div>
                  <div className="dashboardCardSubHeading">Upload your menu files</div>        
                
                <FileUploader
                  multiple
                  name="Menu"
                  className="uploader"
                  filename={() => this.generateFileName()}
                  storageRef={firebase.storage().ref('updates')}
                  onUploadStart={() => this.handleUploadStart()}
                  onUploadError={(error) =>this.handleUploadError(error)}
                  onUploadSuccess={(filename) => this.handleUploadSuccess(filename)}
                />
                {this.state.uploadError ?
                    <div className="alert alert-danger" role="alert">
                        Error uploading!
                    </div>
                    : null
                }
                {this.state.isUploading ? this.spinner : null}
                <p>
                  {this.state.menuUpload.length > 0 ? UPLOADED_TEXT : null}
                </p>
                <button
                  onClick={() => this.submitMenu()}
                  className="honeycombButton" 
                >
                  Submit
                  </button>
              </div>
            </div>
          </div>
          <div className="row">
            {this.havingProblemsCard}
          </div>
        </div>
      </div>
    )
  }
}

export default Update;



// WEBPACK FOOTER //
// ./src/views/Update/Update.js